import "core-js/stable";
import "regenerator-runtime/runtime";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { useIdleTimer } from "react-idle-timer";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { logoutUser } from "@mds/common/redux/actions/authenticationActions";
import keycloak, { keycloakInitConfig } from "@mds/common/keycloak";
import Loading from "@/components/common/Loading";

import App, { store } from "./App";
import "antd/dist/antd.less";
import "./styles/index.scss";
import fetchEnv from "./fetchEnv";
import FeatureFlagProvider from "@mds/common/providers/featureFlags/featureFlag.provider";
import { registerLicense, validateLicense } from "@syncfusion/ej2-base";
import { ENVIRONMENT } from "@mds/common/constants/environment";

const idleTimeout = 5 * 60_000;
const refreshTokenBufferSeconds = 60;

const propTypes = {
  disableEnvLoading: PropTypes.bool,
};

export const Index = (props) => {
  const [environment, setEnvironment] = useState(false);

  if (!props.disableEnvLoading) {
    fetchEnv().then(() => {
      setEnvironment(true);
      registerLicense(ENVIRONMENT.syncfusionLicense);
      const isValidLicense = validateLicense(ENVIRONMENT.syncfusionLicense);
      console.log('syncfusionLicense is valid: ', isValidLicense)
    });
  }

  const { isIdle } = useIdleTimer({
    timeout: idleTimeout,
    throttle: 500,
    crossTab: true,
    syncTimers: 1000,
    events: [
      "mousemove",
      "keydown",
      "wheel",
      "DOMMouseScroll",
      "mousewheel",
      "mousedown",
      "touchstart",
      "touchmove",
      "MSPointerDown",
      "MSPointerMove",
      "visibilitychange",
      "focus",
    ],
  });

  const handleAuthErrors = (err = "") => {
    console.log("Authentication error", err);
    if (!keycloak.authenticated || keycloak.isTokenExpired()) {
      store.dispatch(logoutUser());
      keycloak.clearToken();
    } else {
      console.log("User offline");
    }
  };

  const handleUpdateToken = () => {
    if (keycloak.authenticated && keycloak.tokenParsed) {
      const tokenExpiryTime = keycloak.tokenParsed.exp * 1000;
      const timeToLive = tokenExpiryTime - Date.now() - refreshTokenBufferSeconds * 1000;

      const updateInterval = setInterval(() => {
        if (!isIdle()) {
          keycloak.updateToken(refreshTokenBufferSeconds - 1).catch((err = "") => {
            console.log("Failed to refresh token", err);
            handleAuthErrors();
          });
        }
      }, timeToLive);

      return () => {
        clearInterval(updateInterval);
      };
    }
    return false;
  };

  return environment ? (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={keycloakInitConfig}
      onTokens={() => {
        handleUpdateToken();
      }}
      onTokenExpired={() => {
        if (!isIdle()) {
          keycloak.updateToken();
        }
      }}
      LoadingComponent={<Loading />}
      isLoadingCheck={(kc) => !kc || !environment}
    >
      <FeatureFlagProvider>

        <Provider store={store}>
          <App />
        </Provider>
      </FeatureFlagProvider>
    </ReactKeycloakProvider>

  ) : (
    <Loading />
  );
};

Index.propTypes = propTypes;

const root = document.getElementById("root");
if (root) {
  render(<Index />, root);
}
